<template>
  <v-container grid-list-md>
    <h3> コメント質問
    </h3>
    <comment-question :item="items[i]" v-for=" i in items.index" :key="i" @updateCommentQuestion="updateQuestion(i)"/>
      <!-- <v-card-text>
        {{items}}
        {{comments}}
        <v-layout row>
          <v-flex xs6 sm3>
            <v-text-field label="タイトル" v-model="items[i].name"  ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6 sm3>
            <v-checkbox label="本人に表示" v-model="items[i].isShow.subject" :readonly="false"></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3>
            <v-checkbox label="協力者に表示" v-model="items[i].isShow.coWorker" :readonly="false"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row　v-if="items[i].isShow.subject">
          <v-flex xs2 sm1>
            本人
          </v-flex>
          <v-flex xs12 sm9>

            <vue-editor v-model="items[i].questions.subject" />
          </v-flex>
        </v-layout>
        <v-layout row　v-if="items[i].isShow.coWorker">
          <v-flex xs2 sm1>
            協力者
          </v-flex>
          <v-flex xs12 sm9>
            <vue-editor v-model="items[i].questions.coWorker" />
          </v-flex>

        </v-layout>
        <v-layout row>
          <v-flex xs6 sm3>
            <v-text-field label="最大コメント数" v-model="items[i].maxOfComments"  ></v-text-field>
          </v-flex>
          <v-flex xs6 sm3>
            {{min}}
            <v-text-field label="最小コメント数" v-model="min"  ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row justify-end>
          <v-btn @click="updateQuestion({section_no:i, question:items[i]})">保存</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card> -->
  </v-container>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import CommentQuestion from './comment_question'
export default {
  components: { VueEditor, CommentQuestion },
  props: {
    items: {}
  },
  data() {
    return {
      min:3
    }
  },
  computed:{
    comments(){
      debugger
      return this.items ?
      this.items.forEach(item =>{
        console.log(item)
      })
      : []
        
      }
    
  },
  mounted() {
  },
  methods: {
    updateQuestion(i) {
      debugger
      this.$emit("updateCommentQuestion", {section_no:i, question:this.items[i]})
    }
  }
}
</script>